<template>
  <v-avatar :size="size">
    <img v-if="avatarUrl" :src="url" alt="avatar" />
    <v-icon v-else :size="size">account_circle</v-icon>
  </v-avatar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'user-avatar',
  props: {
    size: { default: 30 },
    avatarUrl: { default: false },
    user: { default: false }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('auth', ['isUser', 'avatar']),
    url() {
      return this.avatarUrl ? this.avatarUrl : this.isUser && this.user ? this.avatar : false;
    }
  }
};
</script>
